import { getTenantId } from './tokenManager';

const PREFIX = 'checkin_ops_rewards_draft';

function draftKey() {
  const t = getTenantId() || 'default';
  return `${PREFIX}_${t}`;
}

export function saveRewardsDraft(rewards) {
  const payload = { savedAt: Date.now(), rewards };
  localStorage.setItem(draftKey(), JSON.stringify(payload));
  return payload;
}

export function loadRewardsDraft() {
  try {
    const raw = localStorage.getItem(draftKey());
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !Array.isArray(data.rewards) || data.rewards.length !== 7) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearRewardsDraft() {
  localStorage.removeItem(draftKey());
}
